import { render, staticRenderFns } from "./Slidegroup.vue?vue&type=template&id=3c374775&"
import script from "./Slidegroup.vue?vue&type=script&lang=js&"
export * from "./Slidegroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports